/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 解绑第三方账户
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class UnbindParams {
  constructor(public bindType?: "WECHAT" | "QQ" | "WEIBO" | "ALIPAY") {}
}

export default async function (
  params: UnbindParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/setting/account/unbinding`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
